import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { registerWebComponents } from "./lib/registerWebComponents";

const CACHE_RESET_VERSION = "2026-04-04-favicon-refresh";

const clearLegacyCaches = async () => {
  if (localStorage.getItem("cache_reset_version") === CACHE_RESET_VERSION) return;

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } finally {
    localStorage.setItem("cache_reset_version", CACHE_RESET_VERSION);
  }
};

// Register Web Components with Shadow DOM
registerWebComponents();

void clearLegacyCaches();

// Clear chunk reload flag after successful load
sessionStorage.removeItem("chunk_reload");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);